import FixScroll from '../helpers/FixScroll'
import CustomSlider from './CustomSlider'

class Preload {
  constructor() {
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.setPreload()
    this.removePreload()
  }

  bindUI() {
    this.ui = {}
    this.ui.$bg = document.querySelectorAll('.js-prehome-background')
    this.ui.$slider = document.querySelector('.js-custom-slider')
    this.ui.$slides = this.ui.$slider.querySelectorAll('.js-custom-slide')
    this.randNbr = Preload.between(0, this.ui.$slides.length)
    this.isLoaded = false
  }

  setPreload() {
    FixScroll.fix()
    this.updateActiveSlide(this.randNbr)
    this.ui.$bg[this.randNbr].style.display = 'block'
    setTimeout(() => {
      this.ui.$bg[this.randNbr].style.opacity = 1  
    }, 500)
  }

  removePreload() {
    setTimeout(() => {
      document.body.removeAttribute('style')
      document.querySelector('.js-prehome').remove()
    }, 8000)
  }

  updateActiveSlide(index) {
    this.ui.$slides[index].classList.add('first')
    this.ui.$slides[index].style.zIndex = '30'
    this.ui.$slides[index].style.transform = 'translate3d(0, 0, 3px)'
    const _that = this

    setTimeout(() => {
      this.ui.$slider.parentNode.classList.add('animated')
      _that.isLoaded = true
      _that.updateCustomSlider(index)
    }, 6000)
  }

  updateCustomSlider(index) {
    if(this.isLoaded) {
      window.customslider = new CustomSlider()
      window.customslider.activeIndex = index
      window.customslider.updateActiveDot(index)
    }
  }

  static between(min, max) {  
    return Math.floor(
      Math.random() * (max - min) + min
    )
  }
}

export default Preload
